<template>
  <div class="projects-view">
    <div class="projects-container">
      <!-- Header -->
      <header class="header">
        <h1 class="title">Projects</h1>
        <p class="subtitle">A few things I’ve built (or am building).</p>
      </header>

      <!-- Grid -->
      <section class="grid">
        <!-- Portfolio -->
        <article class="tile">
          <div class="tile-header">
            <span class="icon">🖥️</span>
            <h3>Portfolio</h3>
          </div>
          <div class="tile-body">
            <p>
              This portfolio is <em>also</em> a project in this portfolio.<br />
              If you’re reading this here, you’re already inside the project. Recursive enough?
            </p>
            <p>
              <a class="link" href="https://www.vunk.pro" target="_blank" rel="noopener">www.vunk.pro</a>
            </p>
          </div>
        </article>

        <!-- BSc Thesis -->
        <article class="tile">
          <div class="tile-header">
            <span class="icon">📚</span>
            <h3>BSc Thesis</h3>
          </div>
          <div class="tile-body">
            <p> Bachelor’s thesis repository with code and materials. </p>
            <p>
              <a class="link" href="https://github.com/koodikirjutaja/CIE" target="_blank" rel="noopener">
                github.com/koodikirjutaja/CIE
              </a>
            </p>
          </div>
        </article>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectsView"
};
</script>

<style scoped>
/* Base layout */
* { margin: 0; padding: 0; box-sizing: border-box; }

.projects-view {
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  color: var(--text-color);
}

.projects-container {
  width: 100%;
  max-width: 1100px;
}

/* Header */
.header { text-align: center; margin-bottom: 28px; }
.title {
  font-size: 2.4rem;
  font-weight: 800;
  letter-spacing: 0.2px;
  margin-bottom: 10px;
  background: linear-gradient(135deg, var(--text-color) 0%, #4CAF50 50%, #2196F3 100%);
  -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
}
.subtitle { font-size: 1.05rem; opacity: 0.85; }

/* Grid / Tiles */
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  align-items: stretch;
}
@media (max-width: 980px) { .grid { grid-template-columns: 1fr 1fr; } }
@media (max-width: 640px) { .grid { grid-template-columns: 1fr; } }

/* Tile style */
.tile {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  padding: 18px 18px;
  display: flex; flex-direction: column;
  transition: border-color .25s, transform .25s, box-shadow .25s;
}
.tile:hover { transform: translateY(-2px); border-color: rgba(255,255,255,0.22); box-shadow: 0 6px 18px rgba(0,0,0,0.25); }

/* Header */
.tile-header { display: flex; justify-content: center; align-items: center; gap: 10px; }
.icon {
  font-size: 1.25rem; width: 30px; height: 30px; display: grid; place-items: center;
  background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.12); border-radius: 8px;
}
.tile-header h3 { font-size: 1.05rem; font-weight: 700; }

/* Body */
.tile-body {
  flex: 1; margin-top: 12px;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  text-align: center; gap: 10px;
}
.tile p { font-size: 0.96rem; line-height: 1.55; max-width: 560px; opacity: 0.95; }
.link { color: #4CAF50; text-decoration: none; border-bottom: 1px dashed rgba(76,175,80,0.6); padding-bottom: 1px; }
.link:hover { opacity: 0.9; }

/* Mobile tweaks */
@media (max-width: 768px) {
  .projects-view { padding: 18px; }
  .title { font-size: 2rem; }
  .subtitle { font-size: 0.98rem; }
  .tile { padding: 16px; }
  .tile-body { gap: 8px; }
  .tile p { font-size: 0.92rem; max-width: 100%; }
}
</style>